import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-logo-brown-dark text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Sobre */}
          <div>
            <h3 className="font-display text-2xl mb-4 text-logo-beige">TUPJA</h3>
            <p className="font-sans text-white/90 leading-relaxed mb-4">
              {t('footer.aboutDesc')}
            </p>
            <p className="font-sans text-sm text-white/70 italic">
              {t('footer.aboutQuote')}
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="font-display text-xl mb-4 text-logo-beige">{t('footer.quickLinks')}</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/sobre-umbanda" className="text-white/80 hover:text-white transition-colors font-sans">
                {t('nav.aboutUmbanda')}
              </Link>
              <Link to="/quem-somos" className="text-white/80 hover:text-white transition-colors font-sans">
                {t('nav.aboutUs')}
              </Link>
              <Link to="/trabalhos-espirituais" className="text-white/80 hover:text-white transition-colors font-sans">
                {t('nav.spiritualWorks')}
              </Link>
              <Link to="/normas" className="text-white/80 hover:text-white transition-colors font-sans">
                {t('nav.houseRules')}
              </Link>
              <Link to="/doacoes" className="text-white/80 hover:text-white transition-colors font-sans">
                {t('nav.donations')}
              </Link>
              <Link to="/instalar" className="text-white/80 hover:text-white transition-colors font-sans flex items-center gap-2">
                <Smartphone className="w-4 h-4" />
                Instalar App
              </Link>
            </nav>
          </div>

          {/* Contato */}
          <div>
            <h3 className="font-display text-xl mb-4 text-logo-beige">{t('nav.contact')}</h3>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-logo-beige mt-1 flex-shrink-0" />
                <p className="text-white/90 font-sans">
                  316 Goodland St<br />
                  Orlando, FL
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-logo-beige flex-shrink-0" />
                <p className="text-white/90 font-sans">
                  (407) 775-8479
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-logo-beige flex-shrink-0" />
                <p className="text-white/90 font-sans">
                  contato@tupja.com
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-white/70 font-sans">
            {t('footer.copyright')}
          </p>
          <p className="text-white/60 font-sans text-sm mt-2">
            {t('footer.axe')}
          </p>
        </div>
      </div>
    </footer>
  );
};
